import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EditMetadata } from '@caslink/common-client';
import { MaxIntValueService } from '@caslink/common-client/ng-app/maxIntValue/MaxIntValueService';
import {
    AbstractControl,
    ControlValueAccessor,
    FormBuilder, FormControl,
    FormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR, ValidationErrors, Validator,
    Validators
} from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cl-job-number',
    templateUrl: './job-number.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: JobNumberComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: JobNumberComponent
        },
    ]
})
export class JobNumberComponent implements OnInit, ControlValueAccessor, OnDestroy, Validator {
    static $name: string = 'clJobNumber';
    public static $controllerAs: string = 'jobNumberCtrl';

    @Input() jobNumber: number;
    @Input() canEdit: boolean;
    @Input() showLabel: boolean;
    @Input() required = false;
    @Output() jobNumberValidChange = new EventEmitter<number>();
    @Output() jobNumberInvalidChange = new EventEmitter<number>();

    form: FormGroup;
    formMetadata: EditMetadata;
    onTouched: Function = () => {};
    onChangeSubs: Subscription[] = [];
    jobNumberCtrl = 'jobNumberCtrl';

    constructor(
        private maxIntValueService: MaxIntValueService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.validateBindings();
        this.initFormGroup();
    }

    ngOnDestroy() {
        for (const sub of this.onChangeSubs) {
            sub.unsubscribe();
        }
    }

    refreshData() {
        this.form.reset();
        this.initFormGroup();
    }

    private initFormGroup() {
        const maxIntValue = this.maxIntValueService.getMaxIntValue();

        const validators = [
            Validators.max(maxIntValue),
            Validators.pattern(/^\d+$/)
        ];

        if (this.required) {
            validators.push(Validators.required);
        }
        this.form = this.formBuilder.group({});

        this.form.addControl(this.jobNumberCtrl, new FormControl(this.jobNumber, {
                validators: validators,
                updateOn: 'change'
            }));
    }

    enterPress($event) {
        $event.preventDefault();
        if (this.form.valid) {
            this.jobNumberValidChange.emit(this.form.controls[this.jobNumberCtrl].value);
        } else {
            this.jobNumberInvalidChange.emit(this.form.controls[this.jobNumberCtrl].value);
        }
    }

    validateBindings() {
        const errMessage = `canEdit MUST be defined in ${JobNumberComponent.$name}! Ensure you are sending the relevant permission from the server`;
        if (typeof this.canEdit === 'undefined') {
            throw new Error(errMessage);
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (this.form.valid) {
            return null;
        }

        let errors : any = {};
        errors = this.addControlErrors(errors, this.jobNumberCtrl);

        return errors;
    }

    registerOnChange(onChange: any) {
        const sub = this.form.valueChanges.subscribe(onChange);
        this.onChangeSubs.push(sub);
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable();
        }
        else {
            this.form.enable();
        }
    }

    writeValue(value: any) {
        if (value) {
            this.form.setValue(value, {emitEvent: false});
        }
    }

    addControlErrors(allErrors: any, controlName:string) {
        const errors = {...allErrors};
        const controlErrors = this.form.controls[controlName].errors;

        if (controlErrors) {
            errors[controlName] = controlErrors;
        }

        return errors;
    }

}
